import React, { useState } from "react";
import useWarehouseDistribution from "../utils/useWarehouseDistribution";
import TableComp from "src/components/shared/table/TableComp";
import useWarehouseDistributionAction from "../utils/useWarehouseDistributionAction";
import { Box, Stack } from "@mui/material";
import SearchFilterComp from "src/components/shared/SearchFilterComp";

export default function BalanceWarehouseTable() {
  const [value, setSearchValue] = useState(null);

  const { header, bodyList, sortData, pagi, setPagi } = useWarehouseDistribution({ product: value ? value : undefined });
  const { action } = useWarehouseDistributionAction();

  return (
    <>
      <Stack mb={2}>
        <Box sx={{ maxWidth: "400px", width: "auto" }}>
          <SearchFilterComp
            selectList={[
              {
                id: 1,
                title: "Sản phẩm",
                value: "products",
              },
            ]}
            getSearchKeyword={setSearchValue}
            autoComplete={{
              products: {
                endpoint: "/api/v1/products",
                limit: 20,
                skip: 0,
                searchField: "name",
                state: setSearchValue,
                label: "Sản phẩm",
                placeholder: "Chọn kho Sản phẩm",
                sx: { width: "100%", borderRadius: "6px", mb: 2 },
              },
            }}
          />
        </Box>
      </Stack>
      <TableComp
        dynamicWidth="600px"
        headers={header}
        bodyList={bodyList}
        sortData={sortData}
        pagi={pagi}
        setPagi={setPagi}
        action={action}
      />
    </>
  );
}
